import { Link } from "react-router-dom";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <span
                aria-hidden
                className="grid h-7 w-7 place-items-center rounded-lg bg-brand-600 text-sm font-bold text-white"
              >
                ◎
              </span>
              <span className="font-bold text-slate-900">
                Concert<span className="text-brand-600">Deals</span>
              </span>
            </div>
            <p className="mt-3 text-sm text-slate-500">
              The cheapest city to see your favorite artist — ticket, flight,
              and hotel, ranked by total all-in cost.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900">Product</h3>
            <ul className="mt-3 space-y-2 text-sm text-slate-500">
              <li>
                <Link to="/search" className="hover:text-brand-700">
                  Search deals
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="hover:text-brand-700">
                  How it works
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900">Popular</h3>
            <ul className="mt-3 space-y-2 text-sm text-slate-500">
              <li>
                <Link
                  to="/search?artist=Taylor%20Swift"
                  className="hover:text-brand-700"
                >
                  Taylor Swift tickets
                </Link>
              </li>
              <li>
                <Link
                  to="/search?artist=Kendrick%20Lamar"
                  className="hover:text-brand-700"
                >
                  Kendrick Lamar tickets
                </Link>
              </li>
              <li>
                <Link
                  to="/search?artist=Olivia%20Rodrigo"
                  className="hover:text-brand-700"
                >
                  Olivia Rodrigo tickets
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-slate-900">Legal</h3>
            <ul className="mt-3 space-y-2 text-sm text-slate-500">
              <li>
                <Link to="/how-it-works#affiliate" className="hover:text-brand-700">
                  Affiliate disclosure
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-slate-100 pt-6 text-xs text-slate-400">
          <p>
            © {year} ConcertDeals. Prices are estimates from third-party
            providers and may change at booking. ConcertDeals earns a commission
            on some bookings at no extra cost to you.
          </p>
        </div>
      </div>
    </footer>
  );
}
